import { createContext, useState } from "react";

import { getLenderByBuyer } from "../util/lenders";
import { progress } from "../util/reverseRequiredInfo";
import { submitWrapper } from "../util/httpHelpers";
import { useNavigate } from "react-router-dom";

const Context = createContext(null);

const twilioBaseUrl = "https://data.bankradar.com/legacy/twilio-2fa/";

export const ContextProvider = ({ children, ppcid, cid, gclid, tsid, fullQueryString }) => {
  const navigator = useNavigate();

  const [state, setState] = useState({
    ppcid: ppcid,
    cid: cid,
    tsid: tsid,
    gclid: gclid,
    fullQueryString: fullQueryString,
    firstName: "",
    lastName: "",
    age: "",
    zipCode: "",
    mortgageBalance: 0,
    homeValue: 200000,
    address: "",
    city: "",
    state: "",
    googleAddressValue: "",
    phoneNumber: "",
    email: "",
    isFetchResult: false,
    passedVerification: true,
    errorMessage: "",
    matchedLender: null,
  });

  const handleUpdateFormValue = (name, value) => {
    setState((state) => ({
      ...state,
      [name]: value,
    }));
  };

  const navigate = (navPath, prevStep) => {
    handleUpdateFormValue("errorMessage", "");

    window.dataLayer.push({
      flow_step: progress[prevStep] || 0,
      flow_description: prevStep,
      event: "stepChange",
    });

    navigator({
      pathname: `/${navPath}`,
      search: state.fullQueryString,
    });
  };

  function generateTwilioCode(phoneNumber, method) {
    const twilioUrl = `${twilioBaseUrl}?type=send&phone=${phoneNumber}&method=${method}`;

    fetch(twilioUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
      })
  }

  async function checkTwilioCode(code) {
    const twilioUrl = `${twilioBaseUrl}?type=verify&phone=${state.phoneNumber}&code=${code}`;

    try {
      const response = await fetch(twilioUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return await response.json();
    } catch (error) { }
  }


  async function handleSubmit(isVerified) {
    handleUpdateFormValue("isFetchResult", true);
    handleUpdateFormValue("passedVerification", isVerified);
    const buyer = await submitWrapper(state, progress.Result, isVerified);
    const lender = getLenderByBuyer(buyer);
    handleUpdateFormValue("matchedLender", lender);
    handleUpdateFormValue("isFetchResult", false);
  }

  return (
    <Context.Provider
      value={{
        cashOut: state.cashOut,
        firstName: state.firstName,
        lastName: state.lastName,
        age: state.age,
        zipCode: state.zipCode,
        mortgageBalance: state.mortgageBalance,
        homeValue: state.homeValue,
        address: state.address,
        googleAddressValue: state.googleAddressValue,
        email: state.email,
        cid: state.cid,
        ppcid: state.ppcid,
        city: state.city,
        state: state.state,
        phoneNumber: state.phoneNumber,
        errorMessage: state.errorMessage,
        isFetchResult: state.isFetchResult,
        passedVerification: state.passedVerification,
        fullQueryString: state.fullQueryString,
        matchedLender: state.matchedLender,
        generateTwilioCode,
        checkTwilioCode,
        handleSubmit,
        handleUpdateFormValue,
        navigate,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export const ContextConsumer = Context.Consumer;

export default Context;
